import { render, staticRenderFns } from "./TablesDropdown.vue?vue&type=template&id=8237d15a&"
import script from "./TablesDropdown.vue?vue&type=script&lang=js&"
export * from "./TablesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports